import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstUpperBold',
})
export class FirstUpperBoldPipe implements PipeTransform {
  transform(value: string): string {
    const array = (value && value.split(' ')) || [];
    if (array.length) {
      array[0] = `<strong>${array[0].toUpperCase()}</strong>`;
    }
    return array.join(' ');
  }
}
